import axios from "axios";
import { buildApiUrl } from "../config/api";
import { TimeEntry } from "./timeTracking";

export type SortField =
  | "userName"
  | "description"
  | "location"
  | "startTime"
  | "endTime"
  | "duration"
  | "createdAt";

export type SortOrder = "asc" | "desc";

export interface TimeEntryWithUser extends TimeEntry {
  userName?: string;
  userEmail?: string;
}

export interface AdminEntriesParams {
  page?: number;
  pageSize?: number;
  sortField?: SortField;
  sortOrder?: SortOrder;
  userId?: string;
}

export interface AdminEntriesPagination {
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface AdminEntriesResponse {
  entries: TimeEntryWithUser[];
  pagination: AdminEntriesPagination;
}

export class AdminEntriesService {
  /**
   * Get all time entries with server-side pagination and sorting
   * For use in Entry Management page (admin/reader only)
   */
  static async getEntries(params: AdminEntriesParams = {}): Promise<AdminEntriesResponse> {
    const queryParams: Record<string, string | number> = {};

    if (params.page) queryParams.page = params.page;
    if (params.pageSize) queryParams.pageSize = params.pageSize;
    if (params.sortField) queryParams.sortField = params.sortField;
    if (params.sortOrder) queryParams.sortOrder = params.sortOrder;
    if (params.userId) queryParams.userId = params.userId;

    const response = await axios.get(buildApiUrl("admin/time-entries"), {
      params: queryParams,
    });

    return response.data;
  }
}
